import React from 'react';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import usePreferredLanguage from '../utilities/usePreferredLanguage';
import { translateUiText } from '../utilities/siteTranslations';

const ActiveInactiveDialog = ({ visible, onConfirm, onCancel, status }) => {
    const preferredLanguage = usePreferredLanguage();
    const t = (value) => translateUiText(value, preferredLanguage);
    // Determine the action to show
    const actionText = status ? t('Inactive') : t('Active');
    return (
        <Dialog visible={visible} onHide={onCancel} style={{ width: '350px' }} header={t('Confirm Status Change')} modal closable={true}>
            <div style={{ textAlign: 'center', padding: '1.5rem' }}>
                <div style={{ marginBottom: '1.5rem', fontWeight: 500 }}>{t('Are you sure you want to')} {actionText.toLowerCase()} {t('this item?')}</div>
                <div style={{ display: 'flex', justifyContent: 'center', gap: '1rem' }}>
                    <Button label={actionText} icon={status ? 'pi pi-times' : 'pi pi-check'} className={status ? 'p-button-danger' : 'p-button-success'} onClick={onConfirm} />
                    <Button label={t('Cancel')} icon="pi pi-times" className="p-button-secondary" onClick={onCancel} />
                </div>
            </div>{' '}
        </Dialog>
    );
};

export default ActiveInactiveDialog;
